import DetailsPaneBg from "@common/assets/images/details-pane-icons/details-pane-bg.png";
import styled from "styled-components";

export const TicketContainer = styled.div`
  display: flex;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const TicketInfoWrap = styled.div`
  flex: 1;
  padding: 0 1rem;

  @media (max-width: 768px) {
    padding: 1rem 2rem;

    .scroll-area {
      padding: 0;
      overflow: hidden;
    }
  }
`;

export const TicketDetailsPane = styled.div`
  width: 50rem;
  padding: 1.6rem 1rem;

  .scroll-area {
    background-image: url(${DetailsPaneBg});
    background-size: auto 50rem;
    background-position-x: -0.2rem;
    background-repeat: no-repeat;
    background-attachment: local;
    padding: 3.2rem 0.8rem 3.2rem 2.4rem;
  }

  @media (max-width: 768px) {
    width: auto;
    padding: 2rem 1.5rem;

    .scroll-area {
      background: none;
      padding: 0;
      overflow: hidden;
    }
  }
`;

export const DetailsPaneWrap = styled.div`
  height: 100%;
  border-radius: 2rem;
  cursor: default;
  background-color: #212123;
  border: 1px solid #2b2b2d;
  overflow: hidden;

  @media (max-width: 768px) {
    background: none;
    border: none;
    border-radius: 0;
  }
`;
